import React from "react";
import styles from "./PrivacyPolicyPage.module.scss";

import Footer from '../../components/Footer/Footer';

const PrivacyPolicyPage_En = () => {
  return (
    <>
        <div className={styles.container}>
            <div className={styles.content}>
                <h1>Privacy policy</h1>
                <hr />
                <p>
                    We place great importance on protecting your personal data. 
                    This privacy policy explains how we collect, use, and protect your information.
                </p>

                <h2>1. Data collected</h2>
                <p>We collect the following data:</p>
                <ul>
                    <li>Username (which may be displayed to other users in the game's general ranking)</li>
                    <li>Email address</li>
                    <li>Postal code (used for statistical purposes only)</li>
                </ul>

                <h2>2. Legal basis for processing</h2>
                <p>
                    The processing of your personal data is based on the following legal grounds:
                </p>
                <ul>
                    <li>Contract execution when you use our service.</li>
                    <li>Legitimate interest for displaying the general player ranking.</li>
                </ul>

                <h2>3. Data retention period</h2>
                <p>
                    Your personal data is retained for a period of <strong>3 years</strong>&nbsp;
                    after your last activity on our service. <br/>After this period, it will be deleted.
                </p>

                <h2>4. Use of data</h2>
                <p>We use your data only for:</p>
                <ul>
                    <li>Ensuring the proper functioning of the service</li>
                    <li>Allowing you to log in</li>
                    <li>Compiling game statistics and a general player ranking (username display only)</li>
                    <li>Analyzing the geographical distribution of players (via postal code, anonymously)</li>
                </ul>

                <h2>5. Data protection</h2>
                <p>
                    We implement appropriate technical and organizational measures to 
                    protect your information against unauthorized access, alteration, disclosure, or destruction.
                    These measures include data encryption and strict access controls.
                </p>

                <h2>6. Your rights</h2>
                <p>
                    In accordance with the GDPR, you have the following rights:
                </p>
                <ul>
                    <li>Right of access: You can obtain a copy of your data.</li>
                    <li>Right of rectification: You can correct your information.</li>
                    <li>Right of deletion: You can request the deletion of your data.</li>
                    <li>Right to data portability: You can receive your data in a structured format.</li>
                    <li>Right to restrict processing: Under certain conditions, you can request to limit the use of your data.</li>
                </ul>
                <p>
                    To exercise these rights, contact us at the following address:&nbsp;
                    <a className={styles.link} href="mailto:contact@hatanna-editions.fr">contact@hatanna-editions.fr</a>.
                </p>

                <h2>7. Complaint to the CNIL</h2>
                <p>
                    If you believe that your rights are not being respected, you can file a complaint 
                    with the CNIL (Commission Nationale de l'Informatique et des Libertés) on their official website:
                    <a className={styles.link} href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer"> www.cnil.fr</a>.
                </p>

                <h2>8. Data transfers outside the EU</h2>
                <p>
                    Your data is stored within the European Union. No transfer outside the EU is carried out. Your data is not shared with third parties.
                </p>
            </div>
        </div>

        <Footer/>
    </>
  );
};

export default PrivacyPolicyPage_En;
